"use strict";
var __defProp = Object.defineProperty;
var __getOwnPropDesc = Object.getOwnPropertyDescriptor;
var __getOwnPropNames = Object.getOwnPropertyNames;
var __hasOwnProp = Object.prototype.hasOwnProperty;
var __export = (target, all) => {
  for (var name in all)
    __defProp(target, name, { get: all[name], enumerable: true });
};
var __copyProps = (to, from, except, desc) => {
  if (from && typeof from === "object" || typeof from === "function") {
    for (let key of __getOwnPropNames(from))
      if (!__hasOwnProp.call(to, key) && key !== except)
        __defProp(to, key, { get: () => from[key], enumerable: !(desc = __getOwnPropDesc(from, key)) || desc.enumerable });
  }
  return to;
};
var __toCommonJS = (mod) => __copyProps(__defProp({}, "__esModule", { value: true }), mod);

// src/useDebounce.ts
var useDebounce_exports = {};
__export(useDebounce_exports, {
  useDebounce: () => useDebounce
});
module.exports = __toCommonJS(useDebounce_exports);
var import_react = require("react");
var useDebounce = ({
  callback,
  delay,
  waitForPromises = false
}) => {
  const timeout = (0, import_react.useRef)(null);
  const isPromiseRunning = (0, import_react.useRef)(false);
  const debounced = (0, import_react.useCallback)(
    (...args) => {
      clearTimeout(timeout.current ?? void 0);
      timeout.current = setTimeout(async () => {
        if (callback && !waitForPromises) {
          callback(...args);
        } else if (callback && waitForPromises && !isPromiseRunning.current) {
          isPromiseRunning.current = true;
          await callback(...args);
          isPromiseRunning.current = false;
        }
      }, delay);
    },
    [delay, callback, waitForPromises]
  );
  (0, import_react.useEffect)(() => () => clearTimeout(timeout.current ?? void 0), []);
  return delay >= 0 ? debounced : callback;
};
// Annotate the CommonJS export names for ESM import in node:
0 && (module.exports = {
  useDebounce
});
